import axios from "axios";
import React, { createContext, useContext, useEffect, useState } from "react";
import Swal from "sweetalert2";
import { obtenerRutaPublica } from "../utils/rutaPublica";

const UsuariosContext = createContext();

const initialState = {
  login: false,
  token: "",
  id: "",
  documentoInstructor: "",
  nombreInstructor: "",
  emailInstructor: "",
  rolObjectId: "",
  imgInstructor: "",
  modulos: [],
};

export const UsuariosProvider = (props) => {
  const [usuarios, setUsuarios] = useState(initialState);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const initial = JSON.parse(localStorage.getItem("usuarios"));

    if (initial?.login) {
      setUsuarios(initial);
    } else {
      setUsuarios(initialState);
    }
  }, []);

  const loginUsuarios = async (credenciales, navigate) => {
    try {
      setLoading(true);

      const { data } = await axios.post("/api/auth/login", credenciales);

      if (data.ok) {
        const instructor = data.instructor || {};

        const modulos =
          data.modulos ||
          instructor.modulos ||
          data.permisos ||
          [];

        const nombreInstructor = `
          ${instructor.nombre1Instructor || ""}
          ${instructor.nombre2Instructor || ""}
          ${instructor.apellido1Instructor || ""}
          ${instructor.apellido2Instructor || ""}
        `
          .replace(/\s+/g, " ")
          .trim();

        const usuariosLogin = {
          login: true,
          token: data.token || "",
          id: instructor._id || "",
          documentoInstructor: instructor.documentoInstructor || "",
          nombreInstructor,
          emailInstructor: instructor.emailInstructor || "",
          rolObjectId: instructor.rolObjectId?._id || instructor.rolObjectId || "",
          imgInstructor: instructor.imgInstructor || "",
          modulos,
        };

        localStorage.setItem("usuarios", JSON.stringify(usuariosLogin));
        localStorage.setItem("user", JSON.stringify(usuariosLogin));
        localStorage.setItem("usuario", JSON.stringify(usuariosLogin));
        localStorage.setItem("token", data.token || "");

        localStorage.setItem(
          "permisos",
          JSON.stringify({
            modulos,
          })
        );

        setUsuarios(usuariosLogin);

        Swal.fire({
          icon: "success",
          title: `${data.message}<br><span style="font-size: smaller;">${nombreInstructor}!</span>`,
          showConfirmButton: false,
          timer: 1500,
        });

        navigate("/inicio", { replace: true });
      }
    } catch (error) {
      if (error.response?.data?.message) {
        return Swal.fire({
          icon: "error",
          title: error.response.data.message,
          showConfirmButton: false,
          timer: 1500,
        });
      }

      console.log("error loginUsuarios", error.message);

      Swal.fire({
        icon: "error",
        title: "Error al iniciar sesión",
        text: "No fue posible iniciar sesión",
        showConfirmButton: false,
        timer: 1500,
      });
    } finally {
      setLoading(false);
    }
  };

  const exit = (navigate) => {
    setUsuarios(initialState);

    localStorage.removeItem("usuarios");
    localStorage.removeItem("usuario");
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    localStorage.removeItem("permisos");
    sessionStorage.removeItem("mrgestor_ultima_ruta");

    if (navigate) {
      navigate(obtenerRutaPublica(), { replace: true });
    }
  };

  const value = {
    usuarios,
    loginUsuarios,
    exit,
    loading,
  };

  return <UsuariosContext.Provider value={value} {...props} />;
};

export function useUsuarios() {
  const context = useContext(UsuariosContext);

  if (!context) {
    throw new Error("useUsuarios error");
  }

  return context;
}
